import { useClientPortalInternalData } from '@/pages/client-portal/internal/hooks/use-client-portal-internal-data'

export const useClientPortalInternalContent = () => {
  const { dataClientPortalInternal, isUscisCase, navigateToCaseDetail } = useClientPortalInternalData()

  const caseData = dataClientPortalInternal?.caseInfo
  const companyData = dataClientPortalInternal?.company
  const historyData = dataClientPortalInternal?.history
  const portalOption = dataClientPortalInternal?.portalOption
  const scheduledAlertsData = dataClientPortalInternal?.alertSchedule

  const showsProcessingTimeSection =
    isUscisCase && (portalOption?.processingTime || portalOption?.processingTimeTrend || portalOption?.inquiryDateTrend)
  const showsVisaBulletinSection = isUscisCase && (portalOption?.visaBulletin || portalOption?.visaBulletinTrend)
  const showsOtherCriticalDates = portalOption?.alertSchedule

  return {
    caseData,
    companyData,
    historyData,
    scheduledAlertsData,
    showsProcessingTimeSection,
    showsVisaBulletinSection,
    showsOtherCriticalDates,
    navigateToCaseDetail,
  }
}
